import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Optional, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { StringHelper } from '../../../core/helpers/strings.helper';
import { GeneralService } from '../../../core/services/general.service';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { UserAlias } from '../../../shared/constants';
import { StorageKeys } from '../../../shared/models/storage-keys';


@Component({
	selector: 'app-legal-terms-and-conditions-modal',
	templateUrl: './legal-terms-and-conditions-modal.component.html',
	styleUrls: ['./legal-terms-and-conditions-modal.component.scss']
})
export class LegalTermsAndConditionsModalComponent implements OnInit {

	accept = false;
	isSubmitting = false;
	errorMessage: string;
	docxHtml;
	userRole: string;
	context: string;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		@Optional() public modal: NzModalRef,
		private generalService: GeneralService,
		private http: HttpClient,
		private localStorage: LocalStorageService,
		private sanitizer: DomSanitizer
	) { }

	ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.userRole = this.localStorage.get('selected_role');
		this.showDocumentBasedOnUser(this.userRole);
	}

	showDocumentBasedOnUser(userRole) {
		switch (userRole) {
			case UserAlias.agent:
			case UserAlias.agentManager:
				this.context = 'bo';
				break;

			case UserAlias.areaManager:
			case UserAlias.aggregator:
				this.context = 'brm';
				// BRM
				break;

			case UserAlias.supremeAggregator:
				this.context = 'rm';
				// RM
				break;

			case UserAlias.superAggregator:
				this.context = 'sc';
				break;
		}
		this.getTCDocument();
	}

	getTCDocument() {
		this.generalService.getTermsAndConditionsForBusinessOwner(this.context).then(res => {
			this.docxHtml = this.sanitizer.bypassSecurityTrustHtml(res);
		});
	}

	OnDocumentCheck() {
		//empty function
	}

	backToLogin() {
		this.generalService.logout();
		this.modal.componentInstance.callback();
		this.modal.destroy();

	}

	goToDashboard() {
		this.acceptTermsAndConditions();
	}

	acceptTermsAndConditions() {
		if (!this.accept) {
			return;
		}
		this.isSubmitting = true;
		this.generalService.acceptTermsAndConditions({ accepted: this.accept })
			.then(data => {
				this.isSubmitting = false;
				this.errorMessage = null;
				this.localStorage.save(StorageKeys.terms_and_conditions_status, true);
				if (this.accept) {
					this.modal.componentInstance.callback();
					this.modal.destroy();
				}
			})
			.catch(error => {
				this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
				this.isSubmitting = false;
			});
	}

}
